import type {
  CredentialCookieEntry,
  CredentialHeaderEntry,
} from '../store/credentialAuthMaterialEditStore';

const MASKED_SECRET_VALUE = '*************************************';

function maskValue(value: string): string {
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed === MASKED_SECRET_VALUE) {
    return '—';
  }
  if (trimmed.length <= 8) {
    return '••••';
  }
  return `${trimmed.slice(0, 4)}…${trimmed.slice(-4)}`;
}

export function formatCredentialHeadersForDisplay(
  headers: CredentialHeaderEntry[],
): string {
  if (headers.length === 0) {
    return '—';
  }
  return headers
    .map((header) => `${header.key}: ${maskValue(header.value)}`)
    .join('\n');
}

export function formatCredentialCookiesForDisplay(
  cookies: CredentialCookieEntry[],
): string {
  if (cookies.length === 0) {
    return '—';
  }
  return cookies
    .map((cookie) => `${cookie.name}=${maskValue(cookie.value)}`)
    .join('\n');
}
